import React from 'react';
import '../gral-stylesheets/testimonials.scss';

import testimonials from '../data/users/users-testimonials.json';
import { IconBxChevronLeft, IconBxChevronRight, IconQuoteLeft, IconQuoteRight } from '../icons/icons';



class Testimonials extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      testimonialsToShow: testimonials,
      indexHover: 2,
      arrowVisibility: {
        display: 'none'
      }
    };
  }
  handleMouseLeaveBox = () => {
    this.setState({
      arrowVisibility: {
        display: 'none'
      }
    })
  }
  handleMouseEnterBox = () => {
    this.setState({
      arrowVisibility: {
        visivility: 'visible'
      }
    })
  };
  handleMouseHoverImage = (e) => {
    this.setState({
      indexHover: e.currentTarget.value
    });
  };
  handleClickRight = () => {
    let testimonialsToShow = this.state.testimonialsToShow;
    let cuttingEnd = testimonialsToShow.slice(-1);
    let cuttingRest = testimonialsToShow.slice(0, testimonialsToShow.length - 1)
    this.setState({
      testimonialsToShow: cuttingEnd.concat(cuttingRest)
    });
  };
  handleClickLeft = () => {
    let testimonialsToShow = this.state.testimonialsToShow;
    let cuttingStart = testimonialsToShow.slice(0, 1);
    let cuttingRest = testimonialsToShow.slice(1);
    this.setState({
      testimonialsToShow: cuttingRest.concat(cuttingStart)
    })
  };
  render() {
    let testimonialsToShow = this.state.testimonialsToShow;
    let fiveTestimonials = testimonialsToShow.slice(0, 5);
    let indexHover = this.state.indexHover;
    return (
      <div className='testimonials-container'>
        <div
          className='testimonials-box'
          onMouseEnter={this.handleMouseEnterBox}
          onMouseLeave={this.handleMouseLeaveBox}
        >
          <div className='testimonials-text-container'>
            <div className='testimonials-quote'>
              <i><IconQuoteLeft /></i>
            </div>
            {
              fiveTestimonials 
                .filter((element, index) => indexHover === index)
                .map((element, index) =>
                  <div
                    key={index}
                    className='testimonials-text'>
                    <p className='testimonials-text-testimony'>
                      {element.testimony}
                    </p>
                    <h2 className='testimonials-text-name'>
                      {element.fullName}
                    </h2>
                    <h3 className='testimonials-text-category-talent'>
                      {`${element.category}, ${element.talent}`}
                    </h3>
                  </div>
                )
            }
            <div className='testimonials-quote'>
              <i><IconQuoteRight /></i>
            </div>
          </div>
          <div className='testimonials-carousel-container'>
            <div
              className='testimonials-arrow-container'
              style={this.state.arrowVisibility}
            >
              <div
                className='testimonials-arrow'
                onClick={this.handleClickLeft}
              >
                <i><IconBxChevronLeft /></i>
              </div>
            </div>

            <div className='testimonials-carousel-view'>
              <ul className='testimonials-carousel'>
                {fiveTestimonials.map((element, index) =>
                  <li
                    key={index}
                    className='testimonials-image-container'
                    value={index}
                    onMouseEnter={this.handleMouseHoverImage}
                  >
                    <div className={
                      indexHover === index
                        ? 'colored-border'
                        : 'border'
                    }>
                      <img
                        className={
                          indexHover === index
                            ? 'colored-image'
                            : 'image'
                        }
                        src={element.image}
                        alt={`imagen ${element.fullName}`}
                      /></div>
                  </li>
                )}
              </ul>
            </div>
            <div
              className='testimonials-arrow-container'
              style={this.state.arrowVisibility}
            >
              <div
                className='testimonials-arrow'
                onClick={this.handleClickRight}
              >
                <i><IconBxChevronRight /></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Testimonials;